import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDEtailComponent {


  public CurrentDetail:any=[];
  public MatchDetail:any=[];
  public emojiDetail:any=[];  
  public socialDetail:any=[];
  public loading:boolean = false;
  public imgURL:any='';
  public largeView:any='';


  constructor(public router: Router, public service: GlobalService) { 
    this.CurrentDetail= JSON.parse(localStorage.getItem('hva_content') || '{}');
    this.getDetail(this.CurrentDetail._id);  
    // this.getMatchDetail(this.CurrentDetail._id);
    if(this.CurrentDetail.image ==''){
      this.CurrentDetail.image =this.service.defaultImage;
    } 
    this.imgURL = this.CurrentDetail.image;
  }

  getDetail(id:any){ 
    this.loading=true;
    var url:any='user-detail/'+id;  
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this;  
        let ebookExtension = response.data.document;
        ebookExtension = ebookExtension.split('.').pop();
        if (ebookExtension.toLowerCase() == 'pdf') {
          response.data.document_type='pdf';
        } else {
          response.data.document_type='image';
        }

        // if(response.data.travelPreferenceData.length !=0){
        //   response.data.travelPreferenceDatas='';
        //   response.data.travelPreferenceData.filter((el:any)=>{
        //     if(response.data.travelPreferenceDatas==''){
        //       response.data.travelPreferenceDatas=el.preference;
        //     } else {
        //       response.data.travelPreferenceDatas= el.preference +', '+response.data.travelPreferenceDatas;
        //     }
        //   })
        // }
        if(response.data.interestData.length !=0){
          response.data.interest_name='';
          response.data.interestData.filter((el:any)=>{
            if(response.data.interest_name==''){
              response.data.interest_name=el.name;
            } else {
              response.data.interest_name= el.name +', '+response.data.interest_name;
            }
          })
        } 
          if(response.data.languageData.length !=0){
          response.data.language_name='';
          response.data.languageData.filter((el:any)=>{
            if(response.data.language_name==''){
              response.data.language_name=el.language;
            } else {
              response.data.language_name= el.language +', '+response.data.language_name;
            }
          })
        }   
        if(response.data.gender==1){
          response.data.genders='Male';
        } else {
          response.data.genders='Female';
        }
        // if(response.data.cityPreferenceData.length !=0){
        //   response.data.CityDetail='';
        //   response.data.cityPreferenceData.filter((el:any)=>{
        //     if(response.data.CityDetail==''){
        //       response.data.CityDetail=el.name;
        //     } else {
        //       response.data.CityDetail= el.name+', '+response.data.CityDetail;
        //     }
        //   })
        // }  
        //    if(response.data.countryPreferenceData.length !=0){
        //   response.data.CountryDetail='';
        //   response.data.countryPreferenceData.filter((el:any)=>{
        //     if(response.data.CountryDetail==''){
        //       response.data.CountryDetail=el.name;
        //     } else {
        //       response.data.CountryDetail= el.name+', '+response.data.CountryDetail;
        //     }
        //   })
        // }
        if(response.data.image ==''){
          response.data.image =self.service.defaultImage;
        } 
        this.imgURL = response.data.image;
        this.CurrentDetail=response.data;
        this.loading=false;   

      } else {
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  getMatchDetail(id:any){
    this.loading=true;
    var url:any='match-list/'+id+'?page=1';  
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this;  
        this.loading=false;     
        // if(response.data.interestData.length !=0){
        //   response.data.interest_name='';
        //   response.data.interestData.filter((el:any)=>{
        //     if(el.interest_name==''){
        //       el.interest_name=el.name;
        //     } else {
        //       el.interest_name= el.name +', '+el.interest_name;
        //     }
        //   })
        // }     
        // this.imgURL = response.data.image;
        this.MatchDetail=response.data;
      } else {
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  close(name:any){
    $(name).modal('toggle');
    this.largeView='';
  }

  verifyAccount(id:any,data:any){
    this.loading=true;
    var url='document-verification/'+id;
    this.service.updateApi1({"incomeVerified":data},url).subscribe(((response:any)=>{
      if(response.success==1){
        this.service.successAlert(response.message);
        this.getDetail(id);
        this.loading=false;
      } else {
        this.service.dangerAlert(response.message);
        this.loading=false;
      }
    }))
  }

  download(uri:any){
    var link = document.createElement("a");
    link.download = 'Annual_doc.pdf';
    link.href = uri;
    link.click();
    link.remove();
  }
}
